import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/identification_applewallet_img_01.svg")